// GlobalStyles.js
import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  /* Global Reset and Typography */
  html, body {
    margin: 0;
    padding: 0;
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    color: var(--text-primary);
    background-color: var(--base-color);
    line-height: 1.6;
    transition: background-color 0.3s ease, color 0.3s ease;
  }
  /* Heading Reset and Styles */
  h1, h2, h3, h4, h5, h6 {
    margin: 0;
    font-weight: 600; /* Uniform font weight for all headings */
  }

  /* Anchor Tag Reset */
  body {
    background-color: var(--base-color);
    color: var(--text-primary);
  }
  a {
    text-decoration: none;
    color: var(--primary-blue);
    transition: color 0.3s ease;

    &:hover {
      color: var(--primary-blue-dark);
    }
  }

  /* Exception for mobile menu items - ensure they're visible */
  [data-mobile-menu-item] {
    color: #ffffff !important;
    display: block !important;
    opacity: 1 !important;
    visibility: visible !important;
  }

  /* Button Styling */
  // button {
  //   cursor: pointer;
  //   background-color: var(--primary-color);
  //   border: none;
  //   color: var(--text-color-light);
  //   padding: 0.5rem 1rem;
  //   border-radius: 5px;
  //   transition: background-color 0.3s ease;

  //   &:hover {
  //     background-color: var(--secondary-color);
  //   }
  // }

  /* Define CSS Variables - Blue Theme with Light/Dark Mode */
  :root {
    /* Blue Theme Colors - Logo Blue (#33C1FF) */
    --primary-blue: #33C1FF;
    --primary-blue-dark: #0099CC;
    --primary-blue-light: #70D4FF;
    --accent-blue: #33C1FF;
    --accent-blue-hover: #0099CC;
    
    /* Light Mode (Default) */
    --base-color: #FFFFFF;
    --bg-light: #F8FAFC;
    --bg-section: #FFFFFF;
    --bg-card: #FFFFFF;
    --text-primary: #1E293B;
    --text-secondary: #475569;
    --text-muted: #64748B;
    --border-color: #E2E8F0;
    --nav-bg: #FFFFFF;
    --nav-border: #E2E8F0;
    
    /* Shadows */
    --shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.05);
    --shadow-md: 0 4px 6px rgba(0, 0, 0, 0.07);
    --shadow-lg: 0 10px 15px rgba(0, 0, 0, 0.1);
    --shadow-xl: 0 20px 25px rgba(0, 0, 0, 0.1);
  }

  [data-theme="dark"] {
    /* Dark Mode */
    --base-color: #0F172A;
    --bg-light: #1E293B;
    --bg-section: #1E293B;
    --bg-card: #334155;
    --text-primary: #F1F5F9;
    --text-secondary: #CBD5E1;
    --text-muted: #94A3B8;
    --border-color: #334155;
    --nav-bg: #1E293B;
    --nav-border: #334155;
    
    /* Shadows for dark mode */
    --shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.3);
    --shadow-md: 0 4px 6px rgba(0, 0, 0, 0.4);
    --shadow-lg: 0 10px 15px rgba(0, 0, 0, 0.5);
    --shadow-xl: 0 20px 25px rgba(0, 0, 0, 0.6);
  }

  /* Utility Classes for Spacing and Layout */
  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 15px;
  }

  .center {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

export default GlobalStyles;
